const en = {
  translation: {
    nav: {
      home: "Home",
      classes: "Classes",
      coaches: "Coaches",
      join: "Join Now",
    },
    hero: {
      tagline: "Street Strength, Graffiti Gym",
      subtitle: "Hybrid training where streetwear, festivals and spray paint meet barbells.",
      cta: "Book a Session",
    },
    common: {
      learnMore: "Learn More",
      bookNow: "Book Now",
      viewAll: "View All",
    },
  },
};

const resources = {
  en,
};

export default resources;
